<template>
  <main class="main-container">
    <section class="banner-section">
      <article class="big-banner">
        <img :src="require(`@/assets/images/main/main_banner01${mobileCheck ? '_mo' : ''}.png`)" alt="" />
        <div class="banner-text-box">
          <h4>
            CESCO Science.<br />
            On Life
          </h4>
          <p>
            Providing the best hygienic solutions for <br />
            your everyday environmental concerns.
          </p>
        </div>
      </article>
      <article class="banner-2nd">
        <div>
          <div>
            <div>
              <h4 class="banner-h4">Contact Us</h4>
              <p class="banner-text">If you have any questions, please contact us.</p>
            </div>
            <div>
              <h5 class="banner-h5">Professional Consulting</h5>
              <p class="banner-text">If you want to identify your hygiene issues, we provide the best solutions with a free diagnosis in advance.</p>
            </div>
          </div>
          <button type="button" class="apply-for-a-diagnosis" @click="router.push('/contact')">
            <b>Contact</b>
          </button>
        </div>
      </article>
      <article class="banner-3rd">
        <img src="@/assets/images/main/main_banner02.png" />
        <div>
          <h4 class="banner-h4">Smile with <br v-if="!mobileCheck" />CESCO</h4>
          <p class="banner-text">
            CESCO’s Science <br class="pc_show" />
            manages <br class="mo_show" />your daily life
          </p>
        </div>
      </article>
    </section>

    <section class="section-pest-grids">
      <article class="pest-grids-1-area">
        <h4>What <br class="mo_show" />do you need?</h4>
        <p class="pest-grids-desc">
          Addressing everyday hygiene concerns with <br />
          effective solutions.
        </p>

        <div class="pest-grids-1">
          <div class="pest-grid-item" @click="router.push('/solution/service/total')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M48.2499 76.8C54.6122 76.8 59.7699 66.4846 59.7699 53.76C59.7699 41.0353 54.6122 30.72 48.2499 30.72C41.8876 30.72 36.7299 41.0353 36.7299 53.76C36.7299 66.4846 41.8876 76.8 48.2499 76.8Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M58.0613 41.7311C55.1525 40.2239 51.8117 39.3599 48.2501 39.3599C44.6885 39.3599 41.3381 40.2239 38.4389 41.7311"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.8738 33.3889C44.525 34.4065 46.3394 35.0017 48.2498 35.0017C50.1602 35.0017 51.9842 34.4065 53.6258 33.3889"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M48.25 39.3599V76.7999" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M19.4499 27.2639C19.4499 27.2639 40.8483 6.20153 43.9299 32.1599"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M77.0499 27.2639C77.0499 27.2639 55.6515 6.20153 52.5699 32.1599"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.0435 26.5247L35.5203 29.3951L33.0435 37.5359L38.0739 42.9599"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.146 56.1312H28.4932L31.69 49.9008L36.7492 52.4544"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M27.533 76.8L32.2466 75.2064L33.0434 64.272L38.0738 64.944"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M63.4567 26.5247L60.9799 29.3951L63.4567 37.5359L58.4263 42.9599"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M73.3538 56.1312H68.0066L64.8098 49.9008L59.7506 52.4544"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M68.9671 76.8L64.2535 75.2064L63.4567 64.272L58.4263 64.944"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="pest-grid-label">IPM Solution</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/fly')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M52.7428 28.2145C52.3204 28.2145 51.9748 27.9073 51.9172 27.4849C51.61 27.0337 49.7188 25.9873 48.25 25.9873C46.7812 25.9873 44.8996 27.0337 44.5828 27.4849C44.5252 27.8881 44.17 28.2145 43.7572 28.2145C43.2964 28.2145 42.9124 27.8305 42.9124 27.3697C42.9124 25.8241 46.2916 24.3169 48.2404 24.3169C50.1892 24.3169 53.5684 25.8241 53.5684 27.3697C53.5684 27.8305 53.1844 28.2145 52.7236 28.2145H52.7428Z"
                  fill="white"
                />
                <path
                  d="M52.8292 33.9935C50.9284 33.9935 49.7092 32.3231 49.7092 29.7311C49.7092 27.4943 52.0228 26.5439 52.762 26.5439C54.6436 26.5439 55.9492 27.8591 55.9492 29.7311C55.9492 31.8527 54.9796 33.9935 52.8292 33.9935ZM52.8004 28.2143C52.6276 28.2623 51.37 28.6655 51.37 29.7215C51.37 30.1631 51.4372 32.3039 52.81 32.3039C54.1828 32.3039 54.25 29.8271 54.25 29.7215C54.25 28.7807 53.722 28.2239 52.7908 28.2143H52.8004Z"
                  fill="white"
                />
                <path
                  d="M43.6804 33.9935C41.53 33.9935 40.5604 31.8527 40.5604 29.7311C40.5604 27.8495 41.8756 26.5439 43.7476 26.5439C44.4868 26.5439 46.8004 27.5039 46.8004 29.7311C46.8004 32.3231 45.5812 33.9935 43.6804 33.9935ZM43.7092 28.2143C42.778 28.2335 42.25 28.7807 42.25 29.7215C42.25 29.8271 42.2596 32.3039 43.69 32.3039C45.1204 32.3039 45.13 30.1535 45.13 29.7215C45.13 28.6655 43.8724 28.2623 43.6996 28.2143H43.7092Z"
                  fill="white"
                />
                <path
                  d="M51.034 32.8512H45.4948C45.034 32.8512 44.65 32.4672 44.65 32.0064C44.65 31.5456 45.034 31.1616 45.4948 31.1616H51.034C51.4948 31.1616 51.8788 31.5456 51.8788 32.0064C51.8788 32.4672 51.4948 32.8512 51.034 32.8512Z"
                  fill="white"
                />
                <path
                  d="M49.6324 26.2079C49.498 26.2079 49.354 26.1695 49.2196 26.1023C48.8164 25.8719 48.6628 25.3631 48.8932 24.9599L50.9284 21.3215C51.1588 20.9183 51.6676 20.7647 52.0708 20.9951C52.474 21.2255 52.6276 21.7343 52.3972 22.1375L50.362 25.7759C50.2084 26.0543 49.9204 26.1983 49.6228 26.1983H49.6324V26.2079Z"
                  fill="white"
                />
                <path
                  d="M46.8772 26.2079C46.5796 26.2079 46.3012 26.0543 46.138 25.7855L44.1028 22.1471C43.8724 21.7439 44.026 21.2255 44.4292 21.0047C44.8324 20.7743 45.3508 20.9279 45.5716 21.3311L47.6068 24.9695C47.8372 25.3727 47.6836 25.8911 47.2804 26.1119C47.1556 26.1791 47.002 26.2175 46.8676 26.2175H46.8772V26.2079Z"
                  fill="white"
                />
                <path
                  d="M71.098 73.9585C56.2564 73.9585 47.4148 51.9169 47.4148 48.0001C47.4148 44.0833 54.2692 39.1681 56.2468 39.1681C61.0948 39.1681 76.5028 62.9953 76.5028 68.5537C76.5028 71.8369 74.3812 73.9681 71.0884 73.9681L71.098 73.9585ZM56.2468 40.8481C55.162 40.8865 49.0948 45.0817 49.0948 48.0001C49.0948 51.1297 57.706 72.2785 71.0884 72.2785C74.5444 72.2785 74.8228 69.4177 74.8228 68.5441C74.8228 62.6785 59.242 40.8481 56.2564 40.8385H56.2468V40.8481Z"
                  fill="white"
                />
                <path
                  d="M25.4212 73.9584C22.138 73.9584 20.0068 71.8368 20.0068 68.544C20.0068 62.9952 35.4148 39.1584 40.2628 39.1584C42.2596 39.1584 49.0948 44.1696 49.0948 47.9904C49.0948 51.8112 40.2628 73.9488 25.4116 73.9488L25.4212 73.9584ZM40.2628 40.848C37.2772 40.848 21.6964 62.6976 21.6964 68.5536C21.6964 69.4272 21.9652 72.288 25.4308 72.288C38.8132 72.288 47.4244 51.1488 47.4244 48.0096C47.4244 45.0912 41.3476 40.896 40.2724 40.8576H40.2628V40.848Z"
                  fill="white"
                />
                <path
                  d="M56.2468 40.848C55.786 40.848 55.402 40.464 55.402 40.0032C55.402 35.1168 53.0308 33.8976 52.9252 33.8496C52.5124 33.6576 52.33 33.1488 52.522 32.736C52.714 32.3232 53.2036 32.1408 53.626 32.3232C53.7604 32.3904 57.082 33.9552 57.082 39.9936C57.082 40.4544 56.698 40.8384 56.2372 40.8384L56.2468 40.848Z"
                  fill="white"
                />
                <path
                  d="M40.2628 40.8479C39.802 40.8479 39.418 40.4639 39.418 40.0031C39.418 33.9647 42.7396 32.3903 42.874 32.3327C43.2964 32.1407 43.7956 32.3327 43.9876 32.7455C44.1796 33.1583 43.9876 33.6575 43.5748 33.8495C43.45 33.9071 41.098 35.1359 41.098 40.0031C41.098 40.4639 40.714 40.8479 40.2532 40.8479H40.2628Z"
                  fill="white"
                />
                <path
                  d="M56.0836 38.7264C55.8628 38.7264 55.6612 38.6496 55.4884 38.4864C55.1524 38.1504 55.1524 37.6224 55.4884 37.296L59.9716 32.8128V26.304C59.9716 26.0832 60.0676 25.8624 60.2116 25.7088L69.3604 16.5696C69.6964 16.2336 70.2244 16.2336 70.5508 16.5696C70.8772 16.9056 70.8868 17.4336 70.5508 17.76L61.6612 26.6496V33.1584C61.6612 33.3792 61.5652 33.6 61.4212 33.7536L56.6884 38.4768C56.5252 38.64 56.3044 38.7168 56.0932 38.7168H56.1028L56.0836 38.7264Z"
                  fill="white"
                />
                <path
                  d="M40.426 38.7264C40.2052 38.7264 40.0036 38.6496 39.8308 38.4864L35.098 33.7632C34.9348 33.6 34.858 33.3984 34.858 33.168V26.6592L25.978 17.7696C25.642 17.4336 25.642 16.9056 25.978 16.5792C26.314 16.2528 26.842 16.2432 27.1684 16.5792L36.298 25.7088C36.4612 25.872 36.538 26.0736 36.538 26.304V32.8128L41.0212 37.296C41.3572 37.632 41.3572 38.16 41.0212 38.4864C40.858 38.6496 40.6372 38.7264 40.426 38.7264Z"
                  fill="white"
                />
                <path
                  d="M61.8532 45.5137C61.6324 45.5137 61.4308 45.4369 61.258 45.2737C60.922 44.9377 60.922 44.4097 61.258 44.0833L65.9236 39.4177C66.0868 39.2545 66.2884 39.1777 66.5188 39.1777H73.21L78.7684 36.9505C79.21 36.7777 79.69 36.9889 79.8628 37.4209C80.0356 37.8433 79.8244 38.3425 79.3924 38.5153L73.6804 40.8001C73.5748 40.8385 73.4692 40.8577 73.3732 40.8577H66.8644L62.4388 45.2833C62.2756 45.4465 62.0548 45.5233 61.8436 45.5233H61.8532V45.5137Z"
                  fill="white"
                />
                <path
                  d="M34.6564 45.5136C34.4356 45.5136 34.234 45.4368 34.0612 45.2736L29.6356 40.848H23.1268C23.0212 40.848 22.9156 40.8288 22.8196 40.7904L17.1076 38.5056C16.6852 38.3328 16.4644 37.8528 16.6372 37.4112C16.81 36.9888 17.3092 36.768 17.7316 36.9408L23.29 39.168H29.9812C30.202 39.168 30.4228 39.264 30.5764 39.408L35.2516 44.0736C35.5876 44.4096 35.5876 44.9376 35.2516 45.264C35.0884 45.4272 34.8676 45.504 34.6564 45.504V45.5136Z"
                  fill="white"
                />
                <path
                  d="M48.2596 73.9585C44.506 73.9585 40.666 70.5505 40.5796 62.9185C40.5796 62.4577 40.9444 62.0737 41.4052 62.0641C41.8276 62.0449 42.25 62.4289 42.2596 62.8897C42.3364 69.3601 45.322 72.2593 48.2596 72.2593C51.1972 72.2593 54.1828 69.3601 54.2596 62.8897C54.2596 62.4289 54.6436 62.0257 55.114 62.0641C55.5748 62.0641 55.9588 62.4577 55.9396 62.9185C55.8436 70.5409 52.0132 73.9585 48.2596 73.9585Z"
                  fill="white"
                />
                <path
                  d="M65.3764 79.6704C65.1364 79.6704 64.8772 79.5648 64.7236 79.3632L60.154 73.6512C60.0772 73.5552 60.0292 73.44 59.9908 73.3248L58.7236 68.2272C58.6084 67.776 58.8868 67.3152 59.338 67.2096C59.7892 67.0944 60.25 67.3728 60.3556 67.824L61.5748 72.7488L66.0292 78.3072C66.3172 78.672 66.2596 79.1904 65.9044 79.4976C65.7508 79.6224 65.5588 79.68 65.3764 79.68H65.386L65.3764 79.6704Z"
                  fill="white"
                />
                <path
                  d="M31.1332 79.6704C30.9508 79.6704 30.7684 79.6128 30.6052 79.488C30.25 79.2 30.1828 78.672 30.4804 78.2976L34.9348 72.7392L36.154 67.8144C36.2692 67.3632 36.7204 67.0848 37.1716 67.2C37.6228 67.3152 37.9012 67.7664 37.786 68.2176L36.5188 73.3152C36.4804 73.4304 36.442 73.5456 36.3556 73.6416L31.786 79.3536C31.6228 79.5648 31.3732 79.6608 31.1332 79.6608H31.1428L31.1332 79.6704Z"
                  fill="white"
                />
                <path
                  d="M48.2596 57.9744C46.1188 57.9744 44.938 57.0528 44.8132 56.9472C44.458 56.6496 44.41 56.1216 44.7076 55.7568C45.0052 55.4016 45.5236 55.3536 45.8788 55.6416C45.9268 55.68 46.7332 56.2848 48.25 56.2848C49.7668 56.2848 50.5924 55.6608 50.6212 55.6416C50.9764 55.3536 51.5044 55.4112 51.7924 55.7664C52.0804 56.1216 52.0324 56.64 51.6772 56.9376C51.5524 57.0432 50.3716 57.9648 48.2308 57.9648H48.2404L48.2596 57.9744Z"
                  fill="white"
                />
                <path
                  d="M48.2596 63.6865C46.8676 63.6865 43.6036 63.6865 42.0484 61.4209C41.7796 61.0369 41.8852 60.5089 42.2692 60.2593C42.6532 59.9905 43.1812 60.0961 43.4308 60.4801C44.3524 61.8241 46.3876 62.0161 48.2596 62.0161C50.1316 62.0161 52.1476 61.8337 53.0884 60.4801C53.3572 60.0961 53.8756 60.0001 54.25 60.2593C54.634 60.5281 54.73 61.0465 54.4708 61.4209C52.9156 63.6865 49.6612 63.6865 48.2596 63.6865Z"
                  fill="white"
                />
                <path
                  d="M48.2596 69.3984C45.13 69.3984 43.306 68.64 41.0692 66.3936C40.7428 66.0576 40.7428 65.5296 41.0692 65.2032C41.4052 64.8768 41.9332 64.8768 42.2596 65.2032C44.4004 67.3536 45.8404 67.7184 48.2596 67.7184C50.6788 67.7184 52.1188 67.3536 54.2596 65.2032C54.586 64.8672 55.1236 64.8672 55.45 65.2032C55.786 65.5296 55.786 66.0672 55.45 66.3936C53.2132 68.64 51.3988 69.3984 48.2596 69.3984Z"
                  fill="white"
                />
                <path
                  d="M59.5492 68.8512H59.5108C59.05 68.832 58.6948 68.4384 58.7044 67.9776C59.1076 58.8672 56.9764 49.8528 52.5412 41.8848C52.3108 41.4816 52.4644 40.9632 52.8676 40.7424C53.2708 40.512 53.7892 40.6656 54.01 41.0688C58.5892 49.3056 60.7972 58.6464 60.3748 68.064C60.3556 68.5152 59.9812 68.8704 59.53 68.8704H59.5396L59.5492 68.8512Z"
                  fill="white"
                />
                <path
                  d="M36.9604 68.8512C36.5092 68.8512 36.1444 68.496 36.1156 68.0448C35.6932 58.6272 37.9012 49.296 42.4804 41.0496C42.7108 40.6464 43.2196 40.4928 43.6228 40.7232C44.026 40.9536 44.1796 41.4624 43.9492 41.8656C39.514 49.8336 37.3828 58.848 37.786 67.9584C37.8052 68.4192 37.45 68.8128 36.9796 68.832H36.9412H36.9508L36.9604 68.8512Z"
                  fill="white"
                />
                <path
                  d="M66.8548 73.296C66.394 73.296 66.01 72.9312 66.01 72.4512C65.962 63.0432 64.3012 53.7984 61.066 44.9472C60.9028 44.5056 61.1332 44.0256 61.5652 43.8624C62.0068 43.6992 62.4868 43.9296 62.65 44.3616C65.9524 53.376 67.6516 62.8224 67.69 72.4224C67.69 72.8832 67.3252 73.2672 66.8452 73.2672V73.2864L66.8548 73.296Z"
                  fill="white"
                />
                <path
                  d="M29.6548 73.2959C29.194 73.2959 28.81 72.9119 28.81 72.4511C28.858 62.8511 30.5476 53.4047 33.85 44.3903C34.0132 43.9487 34.4932 43.7375 34.9348 43.8911C35.3764 44.0447 35.5876 44.5343 35.434 44.9759C32.1988 53.8079 30.5284 63.0719 30.49 72.4799C30.49 72.9407 30.106 73.3247 29.6452 73.3247V73.3055L29.6548 73.2959Z"
                  fill="white"
                />
                <path
                  d="M57.7348 53.0975C57.5428 53.0975 57.3508 53.0303 57.1972 52.9055C55.978 51.8687 51.5236 51.7055 49.0084 51.8591C48.5476 51.8783 48.1444 51.5231 48.1252 51.0623C48.106 50.6015 48.4516 50.1983 48.922 50.1791C49.6612 50.1407 56.1508 49.8239 58.282 51.6191C58.6372 51.9167 58.6852 52.4447 58.3876 52.8095C58.2244 53.0015 57.9844 53.1071 57.7444 53.1071L57.7348 53.0975Z"
                  fill="white"
                />
                <path
                  d="M38.7748 53.0977C38.5348 53.0977 38.3044 52.9921 38.1316 52.8001C37.834 52.4449 37.882 51.9169 38.2372 51.6097C40.3684 49.8145 46.8772 50.1217 47.6164 50.1697C48.0772 50.1889 48.4324 50.5921 48.4132 51.0529C48.394 51.5137 48.01 51.8689 47.53 51.8497C45.0148 51.7153 40.5604 51.8689 39.3412 52.8961C39.178 53.0305 38.9956 53.0881 38.8036 53.0881H38.794L38.7748 53.0977Z"
                  fill="white"
                />
                <path
                  d="M65.6932 59.9329C65.482 59.9329 65.2804 59.8561 65.1172 59.7025C64.3876 59.0113 61.018 58.6753 58.9636 58.6753C58.5028 58.6753 58.1188 58.2913 58.1188 57.8305C58.1188 57.3697 58.5028 56.9857 58.9636 56.9857C59.9236 56.9857 64.7812 57.0817 66.2692 58.4737C66.6052 58.8001 66.6244 59.3281 66.3076 59.6641C66.1444 59.8369 65.914 59.9329 65.6932 59.9329Z"
                  fill="white"
                />
                <path
                  d="M30.8164 59.9329C30.5956 59.9329 30.3652 59.8369 30.202 59.6641C29.8756 59.3281 29.9044 58.7905 30.2404 58.4737C31.7188 57.0817 36.5764 56.9857 37.546 56.9857C38.0164 57.0049 38.3908 57.3505 38.3908 57.8305C38.3908 58.3105 38.026 58.6753 37.546 58.6753C35.4916 58.6753 32.122 59.0209 31.3924 59.7025C31.2292 59.8561 31.0276 59.9329 30.8164 59.9329Z"
                  fill="white"
                />
                <path
                  d="M75.466 68.016C75.178 68.016 74.8996 67.8624 74.7364 67.6032C73.738 65.9232 69.2452 65.9424 66.6532 66.3552C66.202 66.4224 65.77 66.1152 65.6836 65.6544C65.6164 65.1936 65.9236 64.7712 66.3844 64.6848C67.1908 64.56 74.2756 63.5328 76.1764 66.7392C76.4164 67.1424 76.282 67.6512 75.8884 67.8912C75.754 67.968 75.6004 68.0064 75.466 68.0064V68.016Z"
                  fill="white"
                />
                <path
                  d="M21.0436 68.016C20.89 68.016 20.746 67.9776 20.6212 67.9008C20.218 67.6608 20.0932 67.152 20.3332 66.7488C22.2436 63.552 29.3284 64.5696 30.1252 64.6944C30.586 64.7616 30.8932 65.2032 30.826 65.664C30.7588 66.1248 30.3172 66.432 29.8564 66.3648C27.2644 65.952 22.7716 65.9232 21.7732 67.6128C21.61 67.8816 21.3316 68.0256 21.0436 68.0256V68.016Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="pest-grid-label">FIC Solution</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/bedbug')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M31.8916 70.3489C31.8244 70.2721 31.7764 70.1953 31.738 70.1089C29.9908 67.2289 29.0788 63.9265 29.1268 60.5569C29.1268 59.0017 29.2612 57.4465 29.53 55.9201C29.53 55.8625 29.5492 55.8049 29.5588 55.7569C29.5876 55.6033 29.6164 55.4593 29.6452 55.3153L26.2756 57.6001V69.6961C26.2756 69.9265 26.1892 70.1377 26.026 70.3009L21.4564 74.8705C21.1204 75.1969 20.5732 75.1873 20.2468 74.8513C19.93 74.5153 19.93 73.9969 20.2468 73.6609L24.5572 69.3505V57.1489C24.5572 56.8609 24.7012 56.6017 24.9316 56.4385L30.2884 52.8193C30.6628 51.6289 31.1332 50.4769 31.6996 49.3633C31.7284 49.2385 31.786 49.1329 31.8724 49.0369C32.602 47.6353 33.4756 46.3105 34.4644 45.0721L29.242 43.3441L23.8756 53.0017C23.7988 53.1361 23.6932 53.2417 23.5684 53.3185L17.866 56.7457C17.7316 56.8225 17.578 56.8705 17.4244 56.8705C16.954 56.8705 16.57 56.4865 16.57 56.0161C16.57 55.7185 16.7236 55.4401 16.9828 55.2865L22.4932 51.9745L28.09 41.9041C28.2916 41.5489 28.714 41.3761 29.1076 41.5105L35.674 43.6801C36.298 43.0081 36.9604 42.3745 37.6516 41.7697L34.0996 39.6289C33.9076 39.5137 33.7636 39.3217 33.706 39.1009L31.5172 30.3553L27.3028 28.2433C26.8804 28.0321 26.7076 27.5137 26.9188 27.0913C27.13 26.6689 27.6484 26.4961 28.0708 26.7073L32.6404 28.9921C32.8612 29.1073 33.0244 29.3089 33.0916 29.5489L35.29 38.3425L39.0724 40.6273C39.7252 40.1377 40.282 39.7729 40.714 39.5041C39.8788 38.3233 39.4276 36.9217 39.3988 35.4817C39.3988 32.6017 40.7524 30.5665 42.8452 30.1441C42.826 28.5409 43.3924 26.9857 44.4292 25.7665L40.9828 21.4945H32.266C32.0836 21.4945 31.9012 21.4369 31.7572 21.3217L27.1876 17.8945C26.8132 17.6065 26.7364 17.0785 27.0148 16.6945C27.3028 16.3201 27.8308 16.2433 28.2148 16.5217L32.554 19.7761H41.3956C41.6548 19.7761 41.8948 19.8913 42.058 20.0929L45.8404 24.7873C47.386 24.1921 49.0948 24.1921 50.6308 24.7873L54.4132 20.0929C54.5764 19.8913 54.8164 19.7761 55.0756 19.7761H63.9172L68.2564 16.5217C68.6308 16.2337 69.1684 16.3105 69.4564 16.6945C69.7444 17.0689 69.6676 17.6065 69.2836 17.8945L64.714 21.3217C64.57 21.4369 64.3876 21.4945 64.1956 21.4945H55.4788L52.0324 25.7665C53.0788 26.9857 53.6452 28.5409 53.6164 30.1441C55.7092 30.5665 57.0628 32.6113 57.0628 35.4817C57.034 36.9217 56.5828 38.3329 55.7476 39.5041C56.1796 39.7729 56.746 40.1473 57.3892 40.6273L61.1716 38.3425L63.37 29.5489C63.4276 29.3089 63.5908 29.0977 63.8212 28.9921L68.3908 26.7073C68.8132 26.4961 69.3316 26.6689 69.5428 27.0913C69.754 27.5137 69.5812 28.0321 69.1588 28.2433L64.9444 30.3553L62.7556 39.1009C62.698 39.3217 62.5636 39.5137 62.362 39.6289L58.81 41.7697C59.5012 42.3745 60.1636 43.0081 60.7876 43.6801L67.354 41.5105C67.7476 41.3857 68.17 41.5489 68.3716 41.9041L73.9684 51.9745L79.4788 55.2865C79.8916 55.5169 80.0356 56.0353 79.8052 56.4481C79.5748 56.8609 79.0564 57.0049 78.6436 56.7745C78.634 56.7745 78.6148 56.7553 78.6052 56.7457L72.9028 53.3185C72.778 53.2417 72.6724 53.1361 72.5956 53.0017L67.2292 43.3441L62.0068 45.0721C62.9956 46.3105 63.8692 47.6353 64.5988 49.0369C64.6756 49.1329 64.7332 49.2385 64.762 49.3633C65.3188 50.4769 65.7988 51.6385 66.1732 52.8193L71.53 56.4385C71.7604 56.6017 71.9044 56.8609 71.9044 57.1489V69.3505L76.2148 73.6609C76.5508 73.9969 76.5508 74.5345 76.2148 74.8705C75.8788 75.2065 75.3412 75.2065 75.0052 74.8705L70.4356 70.3009C70.2724 70.1377 70.186 69.9265 70.186 69.6961V57.5905L66.8164 55.3057C66.8452 55.4593 66.874 55.6129 66.9028 55.7665C66.9124 55.8145 66.922 55.8625 66.9316 55.9201C67.2004 57.4561 67.3348 59.0113 67.3348 60.5665C67.3732 63.9361 66.4708 67.2481 64.7236 70.1185C64.6852 70.2049 64.6372 70.2913 64.57 70.3585C59.2228 79.3921 47.578 82.3777 38.5444 77.0305C35.7988 75.3985 33.4948 73.1041 31.8724 70.3585L31.8916 70.3489ZM48.2404 77.9617C53.2516 77.6737 57.9652 75.4465 61.3732 71.7601C57.2068 73.2673 52.8196 74.0353 48.394 74.0257H48.0868C43.6612 74.0257 39.274 73.2673 35.1172 71.7601C38.5252 75.4465 43.2388 77.6737 48.25 77.9617H48.2404ZM48.2404 72.3073C53.4436 72.3361 58.5988 71.2417 63.3508 69.1105C64.2436 67.6225 64.8772 66.0097 65.242 64.3201C54.538 69.6577 41.9428 69.6577 31.2292 64.3201C31.594 66.0097 32.2372 67.6225 33.13 69.1105C37.882 71.2513 43.0276 72.3457 48.2404 72.3169V72.3073ZM48.25 66.6241C54.3076 66.6241 60.2596 65.0977 65.578 62.1889C65.626 61.6609 65.6452 61.1137 65.6452 60.5569C65.6452 59.4817 65.578 58.4065 65.4436 57.3313C54.73 63.2449 41.7412 63.2449 31.0276 57.3313C30.8932 58.3969 30.826 59.4721 30.826 60.5569C30.826 61.1137 30.8452 61.6609 30.8932 62.1889C36.2116 65.0977 42.1636 66.6145 48.2212 66.6241H48.25ZM48.2596 60.0577C54.1636 59.8849 59.9524 58.3393 65.1556 55.5457C65.0308 54.9217 64.8772 54.3169 64.7044 53.7313C64.666 53.6449 64.6372 53.5489 64.618 53.4529C64.3588 52.5889 64.0324 51.7345 63.6676 50.9089C61.0276 52.9825 56.0356 55.7665 48.2404 55.7761C40.4356 55.7665 35.4436 52.9825 32.8036 50.9089C32.4388 51.7345 32.122 52.5889 31.8532 53.4529C31.8436 53.5489 31.8148 53.6449 31.7668 53.7409C31.594 54.3265 31.45 54.9313 31.3252 55.5553C36.538 58.3489 42.3364 59.8945 48.25 60.0673L48.2596 60.0577ZM48.2404 54.0577C53.5204 54.1825 58.6852 52.5217 62.89 49.3345C62.2084 48.0865 61.4116 46.9153 60.5092 45.8209C57.5908 48.2113 53.1844 49.5649 48.2308 49.5649C43.2772 49.5649 38.8708 48.2113 35.9524 45.8209C35.05 46.9153 34.2532 48.0865 33.5716 49.3345C37.7764 52.5217 42.9508 54.1921 48.2212 54.0673L48.2404 54.0577ZM48.2404 47.8561C52.7716 47.8561 56.7652 46.6561 59.3764 44.5441C58.6372 43.7761 57.8404 43.0561 57.0052 42.3937C56.89 42.3361 56.794 42.2593 56.7172 42.1633C56.074 41.6641 55.3924 41.2129 54.6916 40.8001C52.6564 42.9601 49.8148 44.2849 48.2404 44.2849C46.666 44.2849 43.8244 42.9601 41.7892 40.8001C41.0884 41.2129 40.4164 41.6641 39.7636 42.1633C39.6868 42.2593 39.5908 42.3361 39.4756 42.3937C38.6308 43.0561 37.8436 43.7761 37.0948 44.5537C39.706 46.6657 43.6996 47.8657 48.2308 47.8657L48.2404 47.8561ZM48.2404 42.5761C49.5268 42.5761 52.0804 41.2801 53.7604 39.3121C53.8084 39.2161 53.8756 39.1393 53.962 39.0721C54.826 38.0545 55.3252 36.7777 55.3732 35.4433C55.3732 33.6481 54.7012 31.7377 52.81 31.7377H43.6804C41.7892 31.7377 41.1172 33.6577 41.1172 35.4433C41.1652 36.7777 41.6644 38.0545 42.5284 39.0721C42.6148 39.1393 42.682 39.2257 42.73 39.3217C44.41 41.2897 46.9636 42.5761 48.2404 42.5761ZM51.9268 30.0193C51.9844 28.7233 51.4468 27.4657 50.4772 26.6113C50.4292 26.5825 50.3812 26.5537 50.3332 26.5153H50.3236C49.018 25.8625 47.4916 25.8625 46.186 26.5153H46.1764C46.1764 26.5153 46.0804 26.5921 46.0324 26.6209C45.0532 27.4753 44.5156 28.7329 44.5828 30.0289H51.946L51.9268 30.0193Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="pest-grid-label">Bed bug Control Solution</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/virusCare')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M48.2498 62.4002C56.7329 62.4002 63.6098 55.5233 63.6098 47.0402C63.6098 38.5571 56.7329 31.6802 48.2498 31.6802C39.7667 31.6802 32.8898 38.5571 32.8898 47.0402C32.8898 55.5233 39.7667 62.4002 48.2498 62.4002Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M55.6422 51.84C57.763 51.84 59.4822 50.1208 59.4822 48C59.4822 45.8793 57.763 44.16 55.6422 44.16C53.5214 44.16 51.8022 45.8793 51.8022 48C51.8022 50.1208 53.5214 51.84 55.6422 51.84Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M44.189 56.6402C45.7796 56.6402 47.069 55.3508 47.069 53.7602C47.069 52.1697 45.7796 50.8802 44.189 50.8802C42.5984 50.8802 41.309 52.1697 41.309 53.7602C41.309 55.3508 42.5984 56.6402 44.189 56.6402Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M43.229 42.4702C44.2894 42.4702 45.149 41.6106 45.149 40.5502C45.149 39.4899 44.2894 38.6302 43.229 38.6302C42.1686 38.6302 41.309 39.4899 41.309 40.5502C41.309 41.6106 42.1686 42.4702 43.229 42.4702Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M37.5266 25.9775C40.1935 25.9775 42.3554 23.8156 42.3554 21.1487C42.3554 18.4819 40.1935 16.3199 37.5266 16.3199C34.8597 16.3199 32.6978 18.4819 32.6978 21.1487C32.6978 23.8156 34.8597 25.9775 37.5266 25.9775Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M58.9729 77.7599C61.6397 77.7599 63.8017 75.598 63.8017 72.9311C63.8017 70.2642 61.6397 68.1023 58.9729 68.1023C56.306 68.1023 54.1441 70.2642 54.1441 72.9311C54.1441 75.598 56.306 77.7599 58.9729 77.7599Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M39.3794 25.6129L42.3362 32.7553" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M54.1641 61.3247L57.1209 68.4671" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M22.3592 41.1459C25.0261 41.1459 27.188 38.984 27.188 36.3171C27.188 33.6502 25.0261 31.4883 22.3592 31.4883C19.6923 31.4883 17.5304 33.6502 17.5304 36.3171C17.5304 38.984 19.6923 41.1459 22.3592 41.1459Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M74.1404 62.592C76.8073 62.592 78.9692 60.4301 78.9692 57.7632C78.9692 55.0964 76.8073 52.9344 74.1404 52.9344C71.4736 52.9344 69.3116 55.0964 69.3116 57.7632C69.3116 60.4301 71.4736 62.592 74.1404 62.592Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M26.8229 38.1697L33.9653 41.1265" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M62.5347 52.9537L69.6771 55.9105" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M22.3592 62.592C25.0261 62.592 27.188 60.4301 27.188 57.7632C27.188 55.0964 25.0261 52.9344 22.3592 52.9344C19.6923 52.9344 17.5304 55.0964 17.5304 57.7632C17.5304 60.4301 19.6923 62.592 22.3592 62.592Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M74.1404 41.1459C76.8073 41.1459 78.9692 38.984 78.9692 36.3171C78.9692 33.6502 76.8073 31.4883 74.1404 31.4883C71.4736 31.4883 69.3116 33.6502 69.3116 36.3171C69.3116 38.984 71.4736 41.1459 74.1404 41.1459Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M26.8229 55.9104L33.9653 52.9536" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M62.5347 41.1266L69.6771 38.1698" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M37.5266 77.7599C40.1935 77.7599 42.3554 75.598 42.3554 72.9311C42.3554 70.2642 40.1935 68.1023 37.5266 68.1023C34.8597 68.1023 32.6978 70.2642 32.6978 72.9311C32.6978 75.598 34.8597 77.7599 37.5266 77.7599Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M58.9729 25.9775C61.6397 25.9775 63.8017 23.8156 63.8017 21.1487C63.8017 18.4819 61.6397 16.3199 58.9729 16.3199C56.306 16.3199 54.1441 18.4819 54.1441 21.1487C54.1441 23.8156 56.306 25.9775 58.9729 25.9775Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M39.3794 68.4671L42.3362 61.3247" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M54.1641 32.7552L57.1209 25.6128" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Viruscare <br />Solution</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/airSterile')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M55.1716 71.712C45.9172 71.712 38.3908 64.1856 38.3908 54.9312C38.3908 45.6768 45.9172 38.1504 55.1716 38.1504C64.426 38.1504 71.962 45.6768 71.962 54.9312C71.962 64.1856 64.4356 71.712 55.1716 71.712ZM55.1716 40.0608C46.9732 40.0608 40.3108 46.7328 40.3108 54.9216C40.3108 63.1104 46.9828 69.7824 55.1716 69.7824C63.3604 69.7824 70.042 63.1104 70.042 54.9216C70.042 46.7328 63.37 40.0608 55.1716 40.0608Z"
                  fill="white"
                />
                <path
                  d="M55.1716 81.6C54.6436 81.6 54.2116 81.168 54.2116 80.64V70.752C54.2116 70.224 54.6436 69.792 55.1716 69.792C55.6996 69.792 56.1316 70.224 56.1316 70.752V80.64C56.1316 81.168 55.6996 81.6 55.1716 81.6Z"
                  fill="white"
                />
                <path
                  d="M55.1716 40.0607C54.6436 40.0607 54.2116 39.6287 54.2116 39.1007V29.2127C54.2116 28.6847 54.6436 28.2527 55.1716 28.2527C55.6996 28.2527 56.1316 28.6847 56.1316 29.2127V39.1007C56.1316 39.6287 55.6996 40.0607 55.1716 40.0607Z"
                  fill="white"
                />
                <path
                  d="M39.3508 55.8815H29.4628C28.9348 55.8815 28.5028 55.4495 28.5028 54.9215C28.5028 54.3935 28.9348 53.9615 29.4628 53.9615H39.3508C39.8788 53.9615 40.3108 54.3935 40.3108 54.9215C40.3108 55.4495 39.8788 55.8815 39.3508 55.8815Z"
                  fill="white"
                />
                <path
                  d="M80.89 55.8815H71.002C70.474 55.8815 70.042 55.4495 70.042 54.9215C70.042 54.3935 70.474 53.9615 71.002 53.9615H80.89C81.418 53.9615 81.85 54.3935 81.85 54.9215C81.85 55.4495 81.418 55.8815 80.89 55.8815Z"
                  fill="white"
                />
                <path
                  d="M70.5604 71.2705C70.3108 71.2705 70.0708 71.1745 69.8788 70.9921L65.6164 66.7297C65.242 66.3553 65.242 65.7505 65.6164 65.3761C65.9908 65.0017 66.5956 65.0017 66.97 65.3761L71.2324 69.6385C71.6068 70.0129 71.6068 70.6177 71.2324 70.9921C71.0404 71.1841 70.8004 71.2705 70.5508 71.2705H70.5604Z"
                  fill="white"
                />
                <path
                  d="M44.0356 44.7456C43.786 44.7456 43.546 44.6496 43.354 44.4672L39.1108 40.224C38.7364 39.8496 38.7364 39.2448 39.1108 38.8704C39.4852 38.496 40.09 38.496 40.4644 38.8704L44.7076 43.1136C45.082 43.488 45.082 44.0928 44.7076 44.4672C44.5156 44.6592 44.2756 44.7456 44.026 44.7456H44.0356Z"
                  fill="white"
                />
                <path
                  d="M39.7828 71.2705C39.5332 71.2705 39.2932 71.1745 39.1012 70.9921C38.7268 70.6177 38.7268 70.0129 39.1012 69.6385L43.3636 65.3761C43.738 65.0017 44.3428 65.0017 44.7172 65.3761C45.0916 65.7505 45.0916 66.3553 44.7172 66.7297L40.4548 70.9921C40.2628 71.1841 40.0228 71.2705 39.7732 71.2705H39.7828Z"
                  fill="white"
                />
                <path
                  d="M66.3172 44.7456C66.0676 44.7456 65.8276 44.6496 65.6356 44.4672C65.2612 44.0928 65.2612 43.488 65.6356 43.1136L69.8788 38.8704C70.2532 38.496 70.858 38.496 71.2324 38.8704C71.6068 39.2448 71.6068 39.8496 71.2324 40.224L66.9892 44.4672C66.7972 44.6592 66.5572 44.7456 66.3076 44.7456H66.3172Z"
                  fill="white"
                />
                <path
                  d="M46.3492 61.8143C46.042 61.8143 45.7348 61.6703 45.5524 61.3919C44.266 59.4719 43.5748 57.2351 43.5748 54.9215C43.5748 52.6079 44.2564 50.3711 45.5524 48.4511C45.85 48.0095 46.4452 47.8943 46.8868 48.1919C47.3284 48.4895 47.4436 49.0847 47.146 49.5263C46.0708 51.1199 45.5044 52.9919 45.5044 54.9215C45.5044 56.8511 46.0708 58.7231 47.146 60.3167C47.4436 60.7583 47.3284 61.3535 46.8868 61.6511C46.7236 61.7663 46.5316 61.8143 46.3492 61.8143Z"
                  fill="white"
                />
                <path
                  d="M36.538 33.0721C33.8308 33.0721 31.6228 30.8641 31.6228 28.1569C31.6228 25.4497 33.706 23.3665 36.3172 23.2417C36.778 20.4385 39.2164 18.2881 42.1444 18.2881C45.3988 18.2881 48.0484 20.9377 48.0484 24.1921C48.0484 27.4465 45.3988 30.0961 42.1444 30.0961C41.7988 30.0961 41.4436 30.0577 41.0884 29.9905C40.3492 31.8145 38.5828 33.0625 36.538 33.0625V33.0721ZM36.538 25.1617C34.8868 25.1617 33.5428 26.5057 33.5428 28.1569C33.5428 29.8081 34.8868 31.1521 36.538 31.1521C37.9972 31.1521 39.2356 30.1057 39.4852 28.6561C39.5332 28.3777 39.706 28.1281 39.9556 27.9841C40.2052 27.8401 40.5028 27.8209 40.7716 27.9169C43.5556 28.9537 46.138 26.8417 46.138 24.1921C46.138 21.9937 44.3524 20.2081 42.154 20.2081C39.9556 20.2081 38.1892 21.9745 38.17 24.1537C38.17 24.1921 38.17 24.2401 38.17 24.2593C38.17 24.5377 38.0452 24.8065 37.834 24.9889C37.6132 25.1713 37.3348 25.2481 37.0564 25.2001C36.8932 25.1713 36.7204 25.1425 36.5476 25.1425L36.538 25.1617Z"
                  fill="white"
                />
                <path
                  d="M40.5028 20.4961C40.1284 20.4961 39.7828 20.2849 39.6196 19.9201L37.786 15.7441C37.5748 15.2545 37.786 14.6881 38.2756 14.4769C38.7652 14.2657 39.3316 14.4865 39.5428 14.9665L41.3764 19.1425C41.5876 19.6321 41.3764 20.1985 40.8868 20.4097C40.762 20.4673 40.6276 20.4865 40.5028 20.4865V20.4961Z"
                  fill="white"
                />
                <path
                  d="M46.0132 32.2176C45.6484 32.2176 45.3028 32.016 45.1396 31.6608L43.8148 28.8384C43.594 28.3584 43.7956 27.7824 44.2756 27.5616C44.7556 27.3408 45.322 27.5424 45.5524 28.0224L46.8772 30.8448C47.098 31.3248 46.8964 31.9008 46.4164 32.1216C46.282 32.1792 46.1476 32.208 46.0132 32.208V32.2176Z"
                  fill="white"
                />
                <path
                  d="M50.7076 25.9488C50.65 25.9488 50.5924 25.9488 50.5348 25.9296L47.4724 25.3728C46.954 25.2768 46.6084 24.7776 46.6948 24.2592C46.7908 23.7408 47.29 23.3952 47.8084 23.4816L50.8708 24.0384C51.3892 24.1344 51.7348 24.6336 51.6484 25.152C51.562 25.6128 51.1588 25.9392 50.7076 25.9392V25.9488Z"
                  fill="white"
                />
                <path
                  d="M45.3892 20.9184C45.1972 20.9184 44.9956 20.8608 44.8324 20.736C44.4004 20.4288 44.3044 19.824 44.6116 19.392L46.426 16.8576C46.7332 16.4256 47.338 16.3296 47.77 16.6368C48.202 16.944 48.298 17.5488 47.9908 17.9808L46.1764 20.5152C45.9844 20.7744 45.6964 20.9184 45.3988 20.9184H45.3892Z"
                  fill="white"
                />
                <path
                  d="M30.778 34.0512C30.4996 34.0512 30.2212 33.9264 30.0292 33.696C29.6932 33.2832 29.7604 32.6784 30.1732 32.3424L32.602 30.384C33.0148 30.048 33.6196 30.1152 33.9556 30.528C34.2916 30.9408 34.2244 31.5456 33.8116 31.8816L31.3828 33.84C31.21 33.984 30.9892 34.0512 30.778 34.0512Z"
                  fill="white"
                />
                <path
                  d="M38.074 36.0383C37.6036 36.0383 37.1908 35.6831 37.1236 35.2031L36.7108 32.0831C36.6436 31.5551 37.0084 31.0751 37.5364 31.0079C38.074 30.9311 38.5444 31.3055 38.6116 31.8335L39.0244 34.9535C39.0916 35.4815 38.7268 35.9615 38.1988 36.0287C38.1604 36.0287 38.1124 36.0287 38.074 36.0287V36.0383Z"
                  fill="white"
                />
                <path
                  d="M32.8516 27.1873C32.746 27.1873 32.6308 27.1681 32.5252 27.1297L29.5684 26.0545C29.0692 25.8721 28.81 25.3249 28.9924 24.8257C29.1748 24.3265 29.722 24.0673 30.2212 24.2497L33.178 25.3249C33.6772 25.5073 33.9364 26.0545 33.754 26.5537C33.61 26.9473 33.2452 27.1873 32.8516 27.1873Z"
                  fill="white"
                />
                <path
                  d="M20.554 49.6223C17.2996 49.6223 14.65 46.9727 14.65 43.7183C14.65 40.4639 17.2996 37.8143 20.554 37.8143C23.8084 37.8143 26.458 40.4639 26.458 43.7183C26.458 46.9727 23.8084 49.6223 20.554 49.6223ZM20.554 39.7343C18.3556 39.7343 16.57 41.5199 16.57 43.7183C16.57 45.9167 18.3556 47.7023 20.554 47.7023C22.7524 47.7023 24.538 45.9167 24.538 43.7183C24.538 41.5199 22.7524 39.7343 20.554 39.7343Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="pest-grid-label">Air Sterilize</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/dualcare')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M41.0596 66.3551C33.8596 66.3551 27.994 60.4991 27.994 53.2895C27.994 46.0799 33.85 40.2239 41.0596 40.2239C48.2692 40.2239 54.1252 46.0799 54.1252 53.2895C54.1252 60.4991 48.2692 66.3551 41.0596 66.3551ZM41.0596 42.1535C34.9156 42.1535 29.914 47.1551 29.914 53.2991C29.914 59.4431 34.9156 64.4447 41.0596 64.4447C47.2036 64.4447 52.2052 59.4431 52.2052 53.2991C52.2052 47.1551 47.2036 42.1535 41.0596 42.1535Z"
                  fill="white"
                />
                <path
                  d="M41.0596 73.9201C40.5316 73.9201 40.0996 73.4881 40.0996 72.9601V65.3953C40.0996 64.8673 40.5316 64.4353 41.0596 64.4353C41.5876 64.4353 42.0196 64.8673 42.0196 65.3953V72.9601C42.0196 73.4881 41.5876 73.9201 41.0596 73.9201Z"
                  fill="white"
                />
                <path
                  d="M41.0596 42.1536C40.5316 42.1536 40.0996 41.7216 40.0996 41.1936V33.6288C40.0996 33.1008 40.5316 32.6688 41.0596 32.6688C41.5876 32.6688 42.0196 33.1008 42.0196 33.6288V41.1936C42.0196 41.7216 41.5876 42.1536 41.0596 42.1536Z"
                  fill="white"
                />
                <path
                  d="M28.9636 54.2592H21.3988C20.8708 54.2592 20.4388 53.8272 20.4388 53.2992C20.4388 52.7712 20.8708 52.3392 21.3988 52.3392H28.9636C29.4916 52.3392 29.9236 52.7712 29.9236 53.2992C29.9236 53.8272 29.4916 54.2592 28.9636 54.2592Z"
                  fill="white"
                />
                <path
                  d="M60.73 54.2592H53.1652C52.6372 54.2592 52.2052 53.8272 52.2052 53.2992C52.2052 52.7712 52.6372 52.3392 53.1652 52.3392H60.73C61.258 52.3392 61.69 52.7712 61.69 53.2992C61.69 53.8272 61.258 54.2592 60.73 54.2592Z"
                  fill="white"
                />
                <path
                  d="M52.8292 66.0191C52.5796 66.0191 52.3396 65.9231 52.1476 65.7407L48.8836 62.4767C48.5092 62.1023 48.5092 61.4975 48.8836 61.1231C49.258 60.7487 49.8628 60.7487 50.2372 61.1231L53.5012 64.3871C53.8756 64.7615 53.8756 65.3663 53.5012 65.7407C53.3092 65.9327 53.0692 66.0191 52.8196 66.0191H52.8292Z"
                  fill="white"
                />
                <path
                  d="M32.5444 45.7345C32.2948 45.7345 32.0548 45.6385 31.8628 45.4561L28.618 42.2113C28.2436 41.8369 28.2436 41.2321 28.618 40.8577C28.9924 40.4833 29.5972 40.4833 29.9716 40.8577L33.2164 44.1025C33.5908 44.4769 33.5908 45.0817 33.2164 45.4561C33.0244 45.6481 32.7844 45.7345 32.5348 45.7345H32.5444Z"
                  fill="white"
                />
                <path
                  d="M29.2996 66.0191C29.05 66.0191 28.81 65.9231 28.618 65.7407C28.2436 65.3663 28.2436 64.7615 28.618 64.3871L31.882 61.1231C32.2564 60.7487 32.8612 60.7487 33.2356 61.1231C33.61 61.4975 33.61 62.1023 33.2356 62.4767L29.9716 65.7407C29.7796 65.9327 29.5396 66.0191 29.29 66.0191H29.2996Z"
                  fill="white"
                />
                <path
                  d="M49.5844 45.7345C49.3348 45.7345 49.0948 45.6385 48.9028 45.4561C48.5284 45.0817 48.5284 44.4769 48.9028 44.1025L52.1476 40.8577C52.522 40.4833 53.1268 40.4833 53.5012 40.8577C53.8756 41.2321 53.8756 41.8369 53.5012 42.2113L50.2564 45.4561C50.0644 45.6481 49.8244 45.7345 49.5748 45.7345H49.5844Z"
                  fill="white"
                />
                <path
                  d="M34.3204 58.7903C34.0132 58.7903 33.706 58.6463 33.5236 58.3679C32.5156 56.8607 31.978 55.1135 31.978 53.2895C31.978 51.4655 32.5156 49.7183 33.5236 48.2111C33.8212 47.7695 34.4164 47.6543 34.858 47.9519C35.2996 48.2495 35.4148 48.8447 35.1172 49.2863C34.3204 50.4671 33.898 51.8495 33.898 53.2895C33.898 54.7295 34.3204 56.1119 35.1172 57.2927C35.4148 57.7343 35.2996 58.3295 34.858 58.6271C34.6948 58.7423 34.5028 58.7903 34.3204 58.7903Z"
                  fill="white"
                />
                <path
                  d="M26.8132 36.8161C24.6148 36.8161 22.8292 35.0305 22.8292 32.8321C22.8292 30.7585 24.4228 29.0497 26.4484 28.8673C26.89 26.7073 28.8004 25.0657 31.0948 25.0657C33.706 25.0657 35.8372 27.1969 35.8372 29.8081C35.8372 32.6497 33.2932 34.9345 30.4228 34.5025C29.7892 35.8945 28.3972 36.8257 26.8036 36.8257L26.8132 36.8161ZM26.8132 30.7585C25.6708 30.7585 24.7492 31.6897 24.7492 32.8225C24.7492 33.9553 25.6708 34.8865 26.8132 34.8865C27.8212 34.8865 28.6756 34.1665 28.8388 33.1681C28.8868 32.8897 29.0596 32.6401 29.3092 32.4961C29.5588 32.3521 29.8564 32.3329 30.1252 32.4289C32.1316 33.1777 33.9268 31.6705 33.9268 29.7985C33.9268 28.2433 32.6596 26.9761 31.1044 26.9761C29.5492 26.9761 28.3108 28.2145 28.282 29.7505C28.282 29.7889 28.282 29.8177 28.282 29.8465C28.282 30.1249 28.1572 30.3937 27.946 30.5761C27.7348 30.7585 27.4468 30.8353 27.1684 30.7873C27.0532 30.7681 26.938 30.7489 26.8228 30.7489L26.8132 30.7585Z"
                  fill="white"
                />
                <path
                  d="M29.8468 27.1967C29.4724 27.1967 29.1268 26.9855 28.9636 26.6207L27.562 23.4239C27.3508 22.9343 27.562 22.3679 28.0516 22.1567C28.5412 21.9455 29.1076 22.1567 29.3188 22.6463L30.7204 25.8431C30.9316 26.3327 30.7204 26.8991 30.2308 27.1103C30.106 27.1679 29.9716 27.1871 29.8468 27.1871V27.1967Z"
                  fill="white"
                />
                <path
                  d="M34.0612 36.1536C33.6964 36.1536 33.3508 35.952 33.1876 35.5968L32.1796 33.4368C31.9588 32.9568 32.1604 32.3808 32.6404 32.16C33.1204 31.9392 33.6964 32.1408 33.9172 32.6208L34.9252 34.7808C35.146 35.2608 34.9444 35.8368 34.4644 36.0576C34.33 36.1152 34.1956 36.144 34.0612 36.144V36.1536Z"
                  fill="white"
                />
                <path
                  d="M37.642 31.3632C37.5844 31.3632 37.5268 31.3632 37.4692 31.344L35.1268 30.9216C34.6084 30.8256 34.2628 30.3264 34.3492 29.808C34.4452 29.2896 34.9444 28.944 35.4628 29.0304L37.8052 29.4528C38.3236 29.5488 38.6692 30.048 38.5828 30.5664C38.4964 31.0272 38.0932 31.3536 37.642 31.3536V31.3632Z"
                  fill="white"
                />
                <path
                  d="M33.5812 27.5136C33.3892 27.5136 33.1876 27.456 33.0244 27.3312C32.5924 27.024 32.4964 26.4192 32.8036 25.9872L34.1956 24.048C34.5028 23.616 35.1076 23.52 35.5396 23.8272C35.9716 24.1344 36.0676 24.7392 35.7604 25.1712L34.3684 27.1104C34.1764 27.3696 33.8884 27.5136 33.5908 27.5136H33.5812Z"
                  fill="white"
                />
                <path
                  d="M22.4164 37.5648C22.138 37.5648 21.8596 37.44 21.6676 37.2096C21.3316 36.7968 21.3988 36.192 21.8116 35.856L23.6644 34.3584C24.0772 34.0224 24.682 34.0896 25.018 34.5024C25.354 34.9152 25.2868 35.52 24.874 35.856L23.0212 37.3536C22.8484 37.4976 22.6276 37.5648 22.4164 37.5648Z"
                  fill="white"
                />
                <path
                  d="M27.994 39.0816C27.5236 39.0816 27.1108 38.7264 27.0436 38.2464L26.7268 35.856C26.6596 35.328 27.0244 34.848 27.5524 34.7808C28.09 34.7136 28.5604 35.0784 28.6276 35.6064L28.9444 37.9968C29.0116 38.5248 28.6468 39.0048 28.1188 39.072C28.0804 39.072 28.0324 39.072 27.994 39.072V39.0816Z"
                  fill="white"
                />
                <path
                  d="M23.9908 32.3039C23.8852 32.3039 23.77 32.2847 23.6644 32.2463L21.3988 31.4207C20.8996 31.2383 20.6404 30.6911 20.8228 30.1919C21.0052 29.6927 21.5524 29.4335 22.0516 29.6159L24.3172 30.4415C24.8164 30.6239 25.0756 31.1711 24.8932 31.6703C24.7492 32.0639 24.3844 32.3039 23.9908 32.3039Z"
                  fill="white"
                />
                <path
                  d="M14.5924 49.4687C11.9812 49.4687 9.84998 47.3375 9.84998 44.7263C9.84998 42.1151 11.9812 39.9839 14.5924 39.9839C17.2036 39.9839 19.3348 42.1151 19.3348 44.7263C19.3348 47.3375 17.2036 49.4687 14.5924 49.4687ZM14.5924 41.9039C13.0372 41.9039 11.77 43.1711 11.77 44.7263C11.77 46.2815 13.0372 47.5487 14.5924 47.5487C16.1476 47.5487 17.4148 46.2815 17.4148 44.7263C17.4148 43.1711 16.1476 41.9039 14.5924 41.9039Z"
                  fill="white"
                />
                <path
                  d="M71.0884 39.3312C68.5732 39.3312 67.2868 37.5168 66.2596 36.0672C65.6068 35.1456 64.9828 34.272 64.1572 33.8688C63.6772 33.6384 63.4852 33.0624 63.7156 32.5824C63.946 32.1024 64.522 31.9104 65.002 32.1408C66.2788 32.7648 67.066 33.8784 67.834 34.9632C68.9092 36.4896 69.6484 37.4208 71.098 37.4208C72.5476 37.4208 73.2772 36.4896 74.3524 34.9632C75.3796 33.504 76.6564 31.6896 79.1812 31.6896C81.706 31.6896 82.9828 33.504 84.01 34.9536C84.6628 35.8752 85.2868 36.7584 86.122 37.1616C86.602 37.392 86.794 37.968 86.5636 38.448C86.3332 38.928 85.7572 39.12 85.2772 38.8896C84.0004 38.2656 83.2036 37.152 82.4452 36.0672C81.37 34.5408 80.6308 33.6096 79.1812 33.6096C77.7316 33.6096 77.002 34.5408 75.9268 36.0672C74.8996 37.5264 73.6228 39.3408 71.098 39.3408L71.0884 39.3312Z"
                  fill="white"
                />
                <path
                  d="M71.0884 51.8304C68.5732 51.8304 67.2868 50.016 66.2596 48.5664C65.6068 47.6448 64.9828 46.7712 64.1572 46.368C63.6772 46.1376 63.4852 45.5616 63.7156 45.0816C63.946 44.6016 64.522 44.4096 65.002 44.64C66.2788 45.264 67.066 46.3776 67.834 47.4624C68.9092 48.9888 69.6484 49.92 71.098 49.92C72.5476 49.92 73.2772 48.9888 74.3524 47.4624C75.3796 46.0032 76.6564 44.1888 79.1812 44.1888C81.706 44.1888 82.9828 46.0032 84.01 47.4528C84.6628 48.3744 85.2868 49.2576 86.122 49.6608C86.602 49.8912 86.794 50.4672 86.5636 50.9472C86.3332 51.4272 85.7572 51.6192 85.2772 51.3888C84.0004 50.7648 83.2036 49.6512 82.4452 48.5664C81.37 47.04 80.6308 46.1088 79.1812 46.1088C77.7316 46.1088 77.002 47.04 75.9268 48.5664C74.8996 50.0256 73.6228 51.84 71.098 51.84L71.0884 51.8304Z"
                  fill="white"
                />
                <path
                  d="M71.0884 64.3201C68.5732 64.3201 67.2868 62.5057 66.2596 61.0561C65.6068 60.1345 64.9828 59.2609 64.1572 58.8577C63.6772 58.6273 63.4852 58.0513 63.7156 57.5713C63.946 57.0913 64.522 56.8993 65.002 57.1297C66.2788 57.7537 67.066 58.8673 67.834 59.9521C68.9092 61.4785 69.6484 62.4097 71.098 62.4097C72.5476 62.4097 73.2772 61.4785 74.3524 59.9521C75.3796 58.4929 76.6564 56.6785 79.1812 56.6785C81.706 56.6785 82.9828 58.4929 84.01 59.9425C84.6628 60.8641 85.2868 61.7473 86.122 62.1505C86.602 62.3809 86.794 62.9569 86.5636 63.4369C86.3332 63.9169 85.7572 64.1089 85.2772 63.8785C84.0004 63.2545 83.2036 62.1409 82.4452 61.0561C81.37 59.5297 80.6308 58.5985 79.1812 58.5985C77.7316 58.5985 77.002 59.5297 75.9268 61.0561C74.8996 62.5153 73.6228 64.3297 71.098 64.3297L71.0884 64.3201Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="pest-grid-label">Air Sterilizer Purifier</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/air')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M52.474 72.6719C50.0452 72.6719 47.3956 71.9999 44.8132 70.0511C44.7748 70.0223 44.7364 69.9935 44.7076 69.9551C44.6116 69.8591 35.4436 60.2303 44.2756 50.1887C52.81 40.4927 69.3316 40.2335 70.0324 40.2335C70.4452 40.2335 70.8484 40.5215 70.9636 40.9439C71.0116 41.1359 75.9172 59.8943 62.4004 69.1871C62.3812 69.2063 57.9748 72.6719 52.4644 72.6719H52.474ZM46.0324 68.5727C53.2516 73.9295 60.9412 67.9103 61.2676 67.6511C72.2404 60.1055 70.0036 45.6191 69.2836 42.1919C65.962 42.3647 52.6852 43.5551 45.7156 51.4655C38.3044 59.8943 45.3028 67.7951 46.0324 68.5727Z"
                  fill="white"
                />
                <path
                  d="M28.7812 65.5199C19.93 65.5199 12.73 58.5599 12.73 49.9967C12.73 42.4415 18.3748 36.0095 25.9876 34.7231C26.3812 24.5087 35.0884 16.3199 45.754 16.3199C55.1524 16.3199 63.082 22.5599 65.05 31.3343C66.6148 30.7583 68.2564 30.4607 69.9364 30.4607C77.5684 30.4607 83.7796 36.4703 83.7796 43.8527C83.7796 51.2351 77.6548 57.1391 70.1188 57.2351H70.1092C69.8116 57.2351 69.5428 57.1007 69.3508 56.8703C69.1684 56.6399 69.1012 56.3327 69.178 56.0448C70.6852 50.0735 69.7156 44.2175 69.2932 42.1919C65.9716 42.3647 52.6948 43.5551 45.7252 51.4655C43.9396 53.5007 42.8452 55.6607 42.49 57.8879C42.4708 58.0223 42.4228 58.1471 42.346 58.2623C39.3892 62.8031 34.3204 65.5199 28.7812 65.5199ZM45.754 18.2399C35.9044 18.2399 27.898 25.9583 27.898 35.4431V35.5583C27.898 36.0479 27.5428 36.4511 27.0532 36.5087C19.9876 37.3343 14.65 43.1423 14.65 49.9967C14.65 57.4944 20.986 63.5999 28.7812 63.5999C33.5908 63.5999 38.0068 61.2767 40.6276 57.3791C41.0788 54.8543 42.3076 52.4447 44.2852 50.1983C52.8196 40.5023 69.3412 40.2431 70.042 40.2431C70.4548 40.2431 70.8676 40.5311 70.9732 40.9535C71.05 41.2511 72.8068 47.8847 71.3188 55.2383C77.2324 54.5663 81.85 49.6895 81.85 43.8527C81.85 37.5263 76.5028 32.3807 69.9268 32.3807C68.122 32.3807 66.3748 32.7743 64.7236 33.5423C64.4452 33.6671 64.138 33.6575 63.8692 33.5231C63.6004 33.3791 63.418 33.1199 63.37 32.8223C62.0452 24.5087 54.4708 18.2399 45.7444 18.2399H45.754Z"
                  fill="white"
                />
                <path
                  d="M40.4164 79.6801C40.3492 79.6801 40.282 79.6801 40.2148 79.6609C39.6964 79.5553 39.3604 79.0465 39.4756 78.5281C43.3252 60.1633 59.1556 51.5713 59.8276 51.2161C60.298 50.9665 60.874 51.1489 61.1236 51.6097C61.3732 52.0801 61.1908 52.6561 60.73 52.9057C60.5764 52.9921 45.0244 61.4497 41.3572 78.9217C41.2612 79.3729 40.8676 79.6801 40.4164 79.6801Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="pest-grid-label">Air Purifier</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/water')">
            <span class="pest-grid-item-img">
              <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M53.6157 37.0558L41.5101 23.0782C40.3677 21.7534 38.3517 21.7534 37.2093 23.0782L25.1037 37.0558C17.2317 46.147 17.2317 60.8926 25.1037 69.9838C32.9757 79.075 45.7437 79.075 53.6157 69.9838C61.4877 60.8926 61.4877 46.147 53.6157 37.0558Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M58.9346 59.0017C63.6674 60.3937 68.8802 58.9057 72.5858 54.4993C78.2114 47.7985 78.2114 36.9313 72.5858 30.2401L63.9362 19.9393C63.1202 18.9601 61.6802 18.9601 60.8642 19.9393L52.2146 30.2401C51.4562 31.1521 50.8034 32.1313 50.2466 33.1777"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.9888 53.51C24.9888 58.1372 26.4768 62.7644 29.4528 66.2012C31.0368 68.0348 32.9088 69.3692 34.9344 70.166"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="pest-grid-label">Water Purifie</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/service/scent')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M70.0804 48.8159H20.9668C20.4388 48.8159 20.0068 48.3839 20.0068 47.8559C20.0068 47.3279 20.4388 46.8959 20.9668 46.8959H70.0804C76.57 46.8959 81.85 41.6543 81.85 35.2031C81.85 28.7519 76.57 23.5103 70.0804 23.5103C69.5524 23.5103 69.1204 23.0783 69.1204 22.5503C69.1204 22.0223 69.5524 21.5903 70.0804 21.5903C77.626 21.5903 83.77 27.6959 83.77 35.2031C83.77 42.7103 77.626 48.8159 70.0804 48.8159Z"
                  fill="white"
                />
                <path
                  d="M70.0804 42.9696C64.1476 42.9696 59.3284 38.1696 59.3284 32.2752C59.3284 26.3808 64.1572 21.5808 70.0804 21.5808C70.6084 21.5808 71.0404 22.0128 71.0404 22.5408C71.0404 23.0688 70.6084 23.5008 70.0804 23.5008C65.2132 23.5008 61.2484 27.4368 61.2484 32.2752C61.2484 37.1136 65.2132 41.0496 70.0804 41.0496C70.6084 41.0496 71.0404 41.4816 71.0404 42.0096C71.0404 42.5376 70.6084 42.9696 70.0804 42.9696Z"
                  fill="white"
                />
                <path
                  d="M70.0804 42.9697C69.5524 42.9697 69.1204 42.5377 69.1204 42.0097C69.1204 41.4817 69.5524 41.0497 70.0804 41.0497C72.7876 41.0497 74.9956 38.8609 74.9956 36.1729C74.9956 33.4849 72.7876 31.2961 70.0804 31.2961C69.5524 31.2961 69.1204 30.8641 69.1204 30.3361C69.1204 29.8081 69.5524 29.3761 70.0804 29.3761C73.8532 29.3761 76.9156 32.4289 76.9156 36.1729C76.9156 39.9169 73.8532 42.9697 70.0804 42.9697Z"
                  fill="white"
                />
                <path
                  d="M44.9764 39.9264H13.69C13.162 39.9264 12.73 39.4944 12.73 38.9664C12.73 38.4384 13.162 38.0064 13.69 38.0064H44.9764C49.4596 38.0064 53.1076 34.3872 53.1076 29.9328C53.1076 25.4784 49.4596 21.8592 44.9764 21.8592C44.4484 21.8592 44.0164 21.4272 44.0164 20.8992C44.0164 20.3712 44.4484 19.9392 44.9764 19.9392C50.5252 19.9392 55.0276 24.4224 55.0276 29.9328C55.0276 35.4432 50.5156 39.9264 44.9764 39.9264Z"
                  fill="white"
                />
                <path
                  d="M44.9764 35.7504C40.5892 35.7504 37.018 32.1984 37.018 27.84C37.018 23.4816 40.5892 19.9296 44.9764 19.9296C45.5044 19.9296 45.9364 20.3616 45.9364 20.8896C45.9364 21.4176 45.5044 21.8496 44.9764 21.8496C41.6452 21.8496 38.938 24.5376 38.938 27.84C38.938 31.1424 41.6452 33.8304 44.9764 33.8304C45.5044 33.8304 45.9364 34.2624 45.9364 34.7904C45.9364 35.3184 45.5044 35.7504 44.9764 35.7504Z"
                  fill="white"
                />
                <path
                  d="M44.9764 35.7505C44.4484 35.7505 44.0164 35.3185 44.0164 34.7905C44.0164 34.2625 44.4484 33.8305 44.9764 33.8305C46.762 33.8305 48.2116 32.3905 48.2116 30.6241C48.2116 28.8577 46.762 27.4177 44.9764 27.4177C44.4484 27.4177 44.0164 26.9857 44.0164 26.4577C44.0164 25.9297 44.4484 25.4977 44.9764 25.4977C47.818 25.4977 50.1316 27.8017 50.1316 30.6241C50.1316 33.4465 47.818 35.7505 44.9764 35.7505Z"
                  fill="white"
                />
                <path
                  d="M54.4708 76.0703C53.9428 76.0703 53.5108 75.6383 53.5108 75.1103C53.5108 74.5823 53.9428 74.1503 54.4708 74.1503C58.954 74.1503 62.602 70.5311 62.602 66.0767C62.602 61.6223 58.954 58.0031 54.4708 58.0031H18.2404C17.7124 58.0031 17.2804 57.5711 17.2804 57.0431C17.2804 56.5151 17.7124 56.0831 18.2404 56.0831H54.4708C60.0196 56.0831 64.522 60.5663 64.522 66.0767C64.522 71.5871 60.01 76.0703 54.4708 76.0703Z"
                  fill="white"
                />
                <path
                  d="M54.4708 76.0704C50.0836 76.0704 46.5124 72.5184 46.5124 68.16C46.5124 63.8016 50.0836 60.2496 54.4708 60.2496C54.9988 60.2496 55.4308 60.6816 55.4308 61.2096C55.4308 61.7376 54.9988 62.1696 54.4708 62.1696C51.1396 62.1696 48.4324 64.8576 48.4324 68.16C48.4324 71.4624 51.1396 74.1504 54.4708 74.1504C54.9988 74.1504 55.4308 74.5824 55.4308 75.1104C55.4308 75.6384 54.9988 76.0704 54.4708 76.0704Z"
                  fill="white"
                />
                <path
                  d="M54.4708 70.5024C53.9428 70.5024 53.5108 70.0704 53.5108 69.5424C53.5108 69.0144 53.9428 68.5824 54.4708 68.5824C56.2564 68.5824 57.706 67.1424 57.706 65.376C57.706 63.6096 56.2564 62.1696 54.4708 62.1696C53.9428 62.1696 53.5108 61.7376 53.5108 61.2096C53.5108 60.6816 53.9428 60.2496 54.4708 60.2496C57.3124 60.2496 59.626 62.5536 59.626 65.376C59.626 68.1984 57.3124 70.5024 54.4708 70.5024Z"
                  fill="white"
                />
                <path
                  d="M20.0356 26.7551C19.2964 26.7551 18.4708 26.6207 17.626 26.3519C15.3892 25.6319 13.8628 24.2015 13.8244 22.7999C13.8244 22.6271 13.8724 22.4543 13.9876 22.3103C14.842 21.1967 16.9252 20.9375 19.1524 21.6671C21.3892 22.3871 22.9156 23.8175 22.954 25.2191C22.954 25.3919 22.906 25.5647 22.7908 25.7087C22.2628 26.3999 21.2548 26.7647 20.026 26.7647L20.0356 26.7551ZM15.4468 23.0591C15.7156 23.6159 16.6276 24.4127 18.106 24.8831C19.5844 25.3631 20.794 25.2479 21.3412 24.9503C21.0724 24.3935 20.1604 23.5967 18.682 23.1263C17.2036 22.6463 15.994 22.7615 15.4468 23.0591Z"
                  fill="white"
                />
                <path
                  d="M24.346 26.7551C23.1172 26.7551 22.1188 26.3903 21.5812 25.6991C21.4756 25.5551 21.418 25.3919 21.418 25.2095C21.4564 23.8079 22.9828 22.3871 25.2196 21.6575C27.4564 20.9375 29.53 21.1967 30.3844 22.3007C30.49 22.4447 30.5476 22.6079 30.5476 22.7903C30.5092 24.1919 28.9828 25.6127 26.746 26.3423C25.9012 26.6111 25.0852 26.7455 24.3364 26.7455L24.346 26.7551ZM23.0404 24.9599C23.5876 25.2575 24.7972 25.3727 26.2756 24.8927C27.754 24.4127 28.666 23.6159 28.9348 23.0687C28.3876 22.7711 27.178 22.6559 25.6996 23.1359C24.2212 23.6159 23.3092 24.4127 23.0404 24.9599Z"
                  fill="white"
                />
                <path
                  d="M22.1956 25.9777C22.1092 25.9777 22.0228 25.9681 21.946 25.9393C20.6212 25.4785 19.7284 23.5873 19.7284 21.2449C19.7284 18.9025 20.6212 17.0209 21.946 16.5505C22.1092 16.4929 22.2916 16.4929 22.4548 16.5505C23.7796 17.0113 24.6724 18.9025 24.6724 21.2449C24.6724 23.5873 23.7796 25.4689 22.4548 25.9393C22.3684 25.9681 22.2916 25.9777 22.2052 25.9777H22.1956ZM22.1956 18.1729C21.7444 18.5953 21.2548 19.6993 21.2548 21.2449C21.2548 22.7905 21.7444 23.8945 22.1956 24.3169C22.6468 23.8945 23.1364 22.7809 23.1364 21.2449C23.1364 19.7089 22.6468 18.5953 22.1956 18.1729Z"
                  fill="white"
                />
                <path
                  d="M17.626 32.5055C17.4148 32.5055 17.2036 32.4767 17.0116 32.4191C16.8484 32.3711 16.6948 32.2655 16.5988 32.1215C15.802 30.9695 16.1956 28.9247 17.578 27.0239C18.9604 25.1327 20.794 24.1343 22.138 24.5279C22.3012 24.5759 22.4548 24.6815 22.5508 24.8255C23.3476 25.9775 22.954 28.0223 21.5716 29.9231C20.3908 31.5359 18.8836 32.5055 17.626 32.5055ZM21.3988 25.9871C20.7844 26.0639 19.7284 26.6783 18.8164 27.9263C17.9044 29.1743 17.6356 30.3551 17.7508 30.9503C18.3652 30.8735 19.4212 30.2591 20.3332 29.0111C21.2452 27.7631 21.514 26.5919 21.3988 25.9871Z"
                  fill="white"
                />
                <path
                  d="M26.7556 32.5055C25.498 32.5055 23.9908 31.5359 22.81 29.9231C21.4276 28.0319 21.034 25.9775 21.8308 24.8255C21.9268 24.6815 22.0804 24.5759 22.2436 24.5279C23.5876 24.1343 25.4212 25.1327 26.8036 27.0239C28.186 28.9151 28.5796 30.9695 27.7828 32.1215C27.6868 32.2655 27.5332 32.3711 27.37 32.4191C27.178 32.4767 26.9668 32.5055 26.7556 32.5055ZM22.9828 25.9871C22.8676 26.5919 23.1364 27.7727 24.0484 29.0111C24.9604 30.2591 26.0164 30.8735 26.6308 30.9503C26.746 30.3455 26.4772 29.1647 25.5652 27.9263C24.6532 26.6783 23.5972 26.0639 22.9828 25.9871Z"
                  fill="white"
                />
                <path
                  d="M75.514 60.5088C74.1796 60.5088 72.6724 59.2704 71.6644 57.312C70.5988 55.2288 70.5316 53.1456 71.5012 52.128C71.6164 52.0032 71.7796 51.9168 71.9524 51.8976C73.354 51.7152 74.9956 52.992 76.0708 55.0752C77.1364 57.1584 77.2036 59.2416 76.234 60.2592C76.1092 60.384 75.9556 60.4704 75.7828 60.4896C75.6964 60.4992 75.6004 60.5088 75.514 60.5088ZM72.4612 53.4528C72.25 54.0288 72.3268 55.2384 73.0372 56.6112C73.7476 57.984 74.6884 58.7616 75.2836 58.9344C75.4948 58.3584 75.418 57.1488 74.7076 55.776C73.9972 54.4032 73.0564 53.6256 72.4612 53.4528Z"
                  fill="white"
                />
                <path
                  d="M81.2836 64.5697C80.3332 64.5697 79.2292 64.2913 78.1252 63.7249C76.0228 62.6593 74.746 61.0177 74.9284 59.6257C74.9476 59.4529 75.034 59.2897 75.1588 59.1649C76.1764 58.2049 78.2692 58.2721 80.362 59.3281C82.4644 60.3937 83.7412 62.0353 83.5588 63.4273C83.5396 63.6001 83.4532 63.7633 83.3284 63.8881C82.8484 64.3393 82.1284 64.5697 81.2836 64.5697ZM76.4836 60.1345C76.6564 60.7201 77.434 61.6513 78.8164 62.3521C80.1988 63.0529 81.418 63.1297 82.0036 62.9185C81.8308 62.3329 81.0532 61.4017 79.6708 60.7009C78.2884 60.0001 77.0692 59.9233 76.4836 60.1345Z"
                  fill="white"
                />
                <path
                  d="M76.3876 60.6144C76.0228 60.6144 75.6772 60.5472 75.3796 60.4032C75.2164 60.3264 75.0916 60.2016 75.0148 60.0384C74.41 58.7712 75.1204 56.8128 76.7812 55.1616C78.442 53.5104 80.41 52.8 81.6772 53.4048C81.8308 53.4816 81.9652 53.6064 82.042 53.7696C82.6468 55.0368 81.946 56.9952 80.2756 58.6464C79.0084 59.904 77.5588 60.6144 76.3876 60.6144ZM76.33 59.0784C76.9156 59.088 78.0868 58.656 79.1908 57.5616C80.2852 56.4768 80.7364 55.3536 80.7172 54.7392C80.074 54.7104 78.9604 55.1616 77.8564 56.256C76.762 57.3408 76.3108 58.464 76.33 59.0784Z"
                  fill="white"
                />
                <path
                  d="M70.57 62.7167C68.842 62.7167 67.45 62.1503 66.9124 61.1615C66.826 61.0079 66.7972 60.8255 66.8356 60.6527C67.0948 59.2799 68.8228 58.1087 71.146 57.7439C73.4692 57.3791 75.4756 57.9551 76.1476 59.1839C76.234 59.3375 76.2628 59.5199 76.2244 59.6927C75.9652 61.0655 74.2372 62.2367 71.914 62.6015C71.4532 62.6783 71.002 62.7071 70.57 62.7071V62.7167ZM68.4676 60.6623C68.9572 61.0367 70.138 61.3343 71.674 61.0943C73.2004 60.8543 74.2276 60.2111 74.5828 59.7023C74.0932 59.3279 72.9124 59.0303 71.3764 59.2703C69.8404 59.5103 68.8132 60.1535 68.4676 60.6623Z"
                  fill="white"
                />
                <path
                  d="M74.602 68.5441C74.4772 68.5441 74.3524 68.5153 74.2372 68.4481C72.9988 67.7857 72.4132 65.7793 72.7876 63.4657C73.1524 61.1521 74.3332 59.4337 75.7156 59.1745C75.8884 59.1457 76.0612 59.1745 76.2148 59.2513C77.4532 59.9137 78.0388 61.9201 77.674 64.2337C77.3092 66.5473 76.1284 68.2657 74.746 68.5249C74.698 68.5249 74.65 68.5345 74.6116 68.5345L74.602 68.5441ZM75.7156 60.8161C75.2068 61.1617 74.5444 62.1793 74.3044 63.7057C74.0644 65.2321 74.362 66.4033 74.746 66.8833C75.2548 66.5377 75.9172 65.5201 76.1572 63.9937C76.3972 62.4673 76.0996 61.2961 75.7156 60.8161Z"
                  fill="white"
                />
                <path
                  d="M22.4932 75.5137C21.6484 75.5137 20.9284 75.2929 20.4484 74.8321C20.3236 74.7073 20.2372 74.5537 20.218 74.3713C20.0356 72.9793 21.322 71.3377 23.4148 70.2721C25.5076 69.2161 27.6004 69.1489 28.618 70.1089C28.7428 70.2337 28.8292 70.3873 28.8484 70.5697C29.0308 71.9617 27.7444 73.6033 25.6516 74.6689C24.5476 75.2257 23.434 75.5137 22.4932 75.5137ZM21.7732 73.8721C22.3588 74.0737 23.578 74.0065 24.9604 73.3057C26.3428 72.6049 27.1204 71.6737 27.2932 71.0881C26.7076 70.8865 25.4884 70.9537 24.106 71.6545C22.7236 72.3553 21.946 73.2865 21.7732 73.8721Z"
                  fill="white"
                />
                <path
                  d="M28.2628 71.4527C28.1764 71.4527 28.0804 71.4527 27.994 71.4335C27.8212 71.4143 27.658 71.3279 27.5428 71.2031C26.5732 70.1855 26.6404 68.1023 27.706 66.0191C28.7716 63.9359 30.4228 62.6591 31.8244 62.8415C31.9972 62.8607 32.1604 62.9471 32.2756 63.0719C33.2452 64.0895 33.178 66.1727 32.1124 68.2559C31.114 70.2047 29.5972 71.4527 28.2724 71.4527H28.2628ZM31.306 64.4063C30.7108 64.5791 29.77 65.3471 29.0596 66.7295C28.3588 68.1023 28.282 69.3119 28.4836 69.8879C29.0788 69.7151 30.0196 68.9471 30.73 67.5647C31.4308 66.1919 31.5076 64.9823 31.306 64.4063Z"
                  fill="white"
                />
                <path
                  d="M27.3892 71.5679C26.2084 71.5679 24.7684 70.8575 23.5012 69.5999C21.8308 67.9487 21.1204 65.9807 21.7348 64.7231C21.8116 64.5695 21.9364 64.4351 22.0996 64.3583C23.3668 63.7535 25.3348 64.4639 26.9956 66.1151C28.6564 67.7663 29.3668 69.7343 28.762 70.9919C28.6852 71.1455 28.5604 71.2799 28.3972 71.3567C28.0996 71.5007 27.754 71.5679 27.3892 71.5679ZM23.0596 65.6831C23.0404 66.2975 23.4916 67.4207 24.586 68.5055C25.69 69.5999 26.8516 70.0415 27.4468 70.0223C27.466 69.4079 27.0148 68.2847 25.9204 67.1999C24.8164 66.1055 23.6932 65.6735 23.0596 65.6831Z"
                  fill="white"
                />
                <path
                  d="M29.1652 79.4881C29.1652 79.4881 29.0692 79.4881 29.0308 79.4785C27.6484 79.2289 26.4676 77.5009 26.1028 75.1873C25.738 72.8737 26.314 70.8769 27.5524 70.2049C27.706 70.1185 27.8788 70.0897 28.0516 70.1281C29.434 70.3777 30.6148 72.1057 30.9796 74.4193C31.3444 76.7329 30.7588 78.7297 29.5204 79.4017C29.4052 79.4593 29.2804 79.4977 29.1556 79.4977L29.1652 79.4881ZM28.0612 71.7697C27.6868 72.2593 27.3796 73.4305 27.6196 74.9473C27.8596 76.4737 28.522 77.4913 29.0308 77.8369C29.4052 77.3473 29.7124 76.1761 29.4724 74.6593C29.2324 73.1329 28.57 72.1153 28.0612 71.7697Z"
                  fill="white"
                />
                <path
                  d="M33.2068 73.6705C32.7748 73.6705 32.3236 73.6321 31.8628 73.5649C29.5396 73.2001 27.802 72.0289 27.5524 70.6561C27.5236 70.4833 27.5524 70.3009 27.6292 70.1473C28.3012 68.9185 30.3076 68.3425 32.6308 68.7073C34.954 69.0721 36.6916 70.2433 36.9412 71.6161C36.97 71.7889 36.9412 71.9713 36.8644 72.1249C36.3268 73.1041 34.9348 73.6801 33.2068 73.6801V73.6705ZM29.1844 70.6465C29.5396 71.1553 30.5668 71.7985 32.0932 72.0385C33.6292 72.2785 34.81 71.9809 35.2996 71.6065C34.9444 71.0977 33.9172 70.4545 32.3908 70.2145C30.8548 69.9745 29.674 70.2721 29.1844 70.6465Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="pest-grid-label"> Fragrance Solution Airperfume </span>
          </div>
        </div>
      </article>
      <article class="pest-grids-2-area">
        <h4>Where <br class="mo_show" />do you need it?</h4>
        <p class="pest-grids-desc">
          Delivering the best solutions for <br />
          each specific area.
        </p>

        <div class="pest-grids-2">
          <div class="pest-grid-item" @click="router.push('/solution/place/home')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M71.54 40.9345V73.9201H25.46V40.9345" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M16.8199 48L48.4999 22.08L80.1799 48" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Homes</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/restaurant')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M68.66 53.76H57.14V79.68H68.66V53.76Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M62.9 39.36V53.76" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M62.9 39.36C67.6718 39.36 71.54 34.2023 71.54 27.84C71.54 21.4777 67.6718 16.32 62.9 16.32C58.1283 16.32 54.26 21.4777 54.26 27.84C54.26 34.2023 58.1283 39.36 62.9 39.36Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M39.86 53.76H28.34V79.68H39.86V53.76Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M34.1 16.32V53.76" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M42.74 16.32V36.48H25.46V16.32" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Dining Establishments</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/retail')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.7 40.9346H31.22V48.6146C31.22 50.7362 29.5016 52.4546 27.38 52.4546H23.54C21.4184 52.4546 19.7 50.7362 19.7 48.6146V40.9346Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.22 40.9346H42.74V48.6146C42.74 50.7362 41.0216 52.4546 38.9 52.4546H35.06C32.9384 52.4546 31.22 50.7362 31.22 48.6146V40.9346Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.74 40.9346H54.26V48.6146C54.26 50.7362 52.5416 52.4546 50.42 52.4546H46.58C44.4584 52.4546 42.74 50.7362 42.74 48.6146V40.9346Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M54.26 40.9346H65.78V48.6146C65.78 50.7362 64.0616 52.4546 61.94 52.4546H58.1C55.9784 52.4546 54.26 50.7362 54.26 48.6146V40.9346Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M65.78 40.9346H77.3V48.6146C77.3 50.7362 75.5816 52.4546 73.46 52.4546H69.62C67.4984 52.4546 65.78 50.7362 65.78 48.6146V40.9346Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M71.54 52.4545V73.9201H25.46V52.4545" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M36.98 73.92V59.52H60.02V73.92" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M67.22 22.08H29.78V30.72H67.22V22.08Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M77.3 40.9345L67.22 30.7201H29.78L19.7 40.9345H77.3Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M36.26 30.7201L31.22 40.9345" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M43.0952 30.7201L42.74 40.9345" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M60.74 30.7201L65.78 40.9345" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M53.9047 30.7201L54.2599 40.9345" stroke="white" stroke-width="2" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label"> Distribution <br />Logistics </span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/edu')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.58 73.92V45.12H74.42V73.92" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M42.74 73.92V59.52H54.26V73.92" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M16.82 73.92H80.18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M48.5 22.08V45.12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M48.5 22.08L62.9 30.72L48.5 39.36" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Educational Facilities</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/building')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35.54 39.36H19.7V71.04H77.3V39.36H61.46" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M35.54 71.04V24.96H61.46V71.04" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M44.18 71.04V56.64H52.82V71.04" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M42.74 33.6H39.86V36.48H42.74V33.6Z" fill="white" />
                <path d="M49.94 33.6H47.06V36.48H49.94V33.6Z" fill="white" />
                <path d="M57.14 33.6H54.26V36.48H57.14V33.6Z" fill="white" />
                <path d="M42.74 42.24H39.86V45.12H42.74V42.24Z" fill="white" />
                <path d="M29.06 48H26.18V50.88H29.06V48Z" fill="white" />
                <path d="M29.06 56.64H26.18V59.52H29.06V56.64Z" fill="white" />
                <path d="M70.82 48H67.94V50.88H70.82V48Z" fill="white" />
                <path d="M70.82 56.64H67.94V59.52H70.82V56.64Z" fill="white" />
                <path d="M49.94 42.24H47.06V45.12H49.94V42.24Z" fill="white" />
                <path d="M57.14 42.24H54.26V45.12H57.14V42.24Z" fill="white" />
              </svg>
            </span>
            <span class="pest-grid-label">Building <br />Facilities</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/service')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.8199 56.64C23.1559 56.64 23.156 62.4 29.492 62.4C35.828 62.4 35.828 56.64 42.164 56.64C48.5 56.64 48.4999 62.4 54.8359 62.4C61.1719 62.4 61.1719 56.64 67.5079 56.64C73.8439 56.64 73.8439 62.4 80.1799 62.4"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.8199 68.16C23.1559 68.16 23.156 73.92 29.492 73.92C35.828 73.92 35.828 68.16 42.164 68.16C48.5 68.16 48.4999 73.92 54.8359 73.92C61.1719 73.92 61.1719 68.16 67.5079 68.16C73.8439 68.16 73.8439 73.92 80.1799 73.92"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.34 62.4V29.28C28.34 25.3056 31.5656 22.08 35.54 22.08C39.5144 22.08 42.74 25.3056 42.74 29.28"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M48.5 59.5296V29.28C48.5 25.3056 51.7256 22.08 55.7 22.08C59.6744 22.08 62.9 25.3056 62.9 29.28"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M28.34 36.48H48.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M28.34 48H48.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Service <br />Facilities</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/culture')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M48.4996 76.7996C64.4054 76.7996 77.2996 63.9054 77.2996 47.9996C77.2996 32.0938 64.4054 19.1996 48.4996 19.1996C32.5938 19.1996 19.6996 32.0938 19.6996 47.9996C19.6996 63.9054 32.5938 76.7996 48.4996 76.7996Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M48.4996 39.3603C51.6807 39.3603 54.2596 36.7814 54.2596 33.6003C54.2596 30.4191 51.6807 27.8403 48.4996 27.8403C45.3184 27.8403 42.7396 30.4191 42.7396 33.6003C42.7396 36.7814 45.3184 39.3603 48.4996 39.3603Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M48.4996 68.1606C51.6807 68.1606 54.2596 65.5818 54.2596 62.4006C54.2596 59.2195 51.6807 56.6406 48.4996 56.6406C45.3184 56.6406 42.7396 59.2195 42.7396 62.4006C42.7396 65.5818 45.3184 68.1606 48.4996 68.1606Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M62.8998 53.7596C66.0809 53.7596 68.6598 51.1807 68.6598 47.9996C68.6598 44.8184 66.0809 42.2396 62.8998 42.2396C59.7186 42.2396 57.1398 44.8184 57.1398 47.9996C57.1398 51.1807 59.7186 53.7596 62.8998 53.7596Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M34.1003 53.7596C37.2814 53.7596 39.8603 51.1807 39.8603 47.9996C39.8603 44.8184 37.2814 42.2396 34.1003 42.2396C30.9191 42.2396 28.3403 44.8184 28.3403 47.9996C28.3403 51.1807 30.9191 53.7596 34.1003 53.7596Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M47.684 76.8004H76.484" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Cultural <br />Facilities</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/medical')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35.54 35.04H19.7V73.92H77.3V35.04H61.46" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path
                  d="M54.26 29.28V22.08H42.74V29.28H35.54V40.8H42.74V48H54.26V40.8H61.46V29.28H54.26Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path d="M52.82 55.2H44.18V68.16H52.82V55.2Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M70.1 55.2H61.46V68.16H70.1V55.2Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M35.54 55.2H26.9V68.16H35.54V55.2Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Medical <br />Facilities</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/hotel')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M77.3 53.76H19.7V65.28H77.3V53.76Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M68.66 24.96H28.34V39.36H68.66V24.96Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M34.1 39.36V30.72H45.62V39.36" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M51.38 39.36V30.72H62.9V39.36" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M77.3 53.76L68.66 39.36" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M28.34 39.36L19.7 53.76" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M25.46 71.0399V65.2799" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M71.54 71.0399V65.2799" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Deluxe Hotels/<br />Resorts</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/motel')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.22 39.36H19.7V76.8H77.3V39.36H65.78" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M31.2201 76.8V19.2H65.7801V76.8" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M39.86 30.72H57.14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M39.86 42.24H57.14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M39.86 53.76H57.14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M39.86 65.2799H57.14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">General Hotels/<br />Hostels</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/foodfactory')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M36.9794 76.7999C34.973 76.7999 33.5809 74.7167 34.2817 72.7583L36.9794 65.2799L39.677 72.7583C40.3778 74.7167 38.9954 76.7999 36.9794 76.7999Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M48.4995 76.7999C46.4931 76.7999 45.101 74.7167 45.8018 72.7583L48.4995 65.2799L51.1971 72.7583C51.8979 74.7167 50.5155 76.7999 48.4995 76.7999Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M60.0194 76.7999C58.013 76.7999 56.621 74.7167 57.3218 72.7583L60.0194 65.2799L62.7171 72.7583C63.4179 74.7167 62.0354 76.7999 60.0194 76.7999Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M62.9 27.84H34.1C30.9188 27.84 28.34 30.4188 28.34 33.6V53.76C28.34 56.9411 30.9188 59.52 34.1 59.52H62.9C66.0811 59.52 68.66 56.9411 68.66 53.76V33.6C68.66 30.4188 66.0811 27.84 62.9 27.84Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path d="M28.34 36.48H68.66" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M19.7 42.24H28.34" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M68.66 42.24H77.3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M45.62 27.84V19.2H51.38V27.84" stroke="white" stroke-width="2" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Food <br />Processing</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/factory')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M58.58 45.12V36.48L38.42 45.12V36.48L18.26 45.12V76.8H38.42H58.58H78.74V36.48L58.58 45.12Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path d="M18.26 45.12V19.2H26.9V41.4144" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M38.42 45.12V19.2H47.06V41.4144" stroke="white" stroke-width="2" stroke-linejoin="round" />
                <path d="M28.34 56.64H25.46V59.52H28.34V56.64Z" fill="white" />
                <path d="M48.5 56.64H45.62V59.52H48.5V56.64Z" fill="white" />
                <path d="M68.66 56.64H65.78V59.52H68.66V56.64Z" fill="white" />
              </svg>
            </span>
            <span class="pest-grid-label">Manufacturing Plant</span>
          </div>
          <div class="pest-grid-item" @click="router.push('/solution/place/storage')">
            <span class="pest-grid-item-img">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M74.42 33.0239V76.7999H28.34" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22.58 36.48L51.38 19.2L80.18 36.48" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M42.74 42.24H16.82V59.52H42.74V42.24Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M48.5 42.24H51.38L57.14 50.88V68.16H52.82" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.7 63.84V68.16H24.02" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M28.34 72.48C30.7258 72.48 32.66 70.5458 32.66 68.16C32.66 65.7741 30.7258 63.84 28.34 63.84C25.9541 63.84 24.02 65.7741 24.02 68.16C24.02 70.5458 25.9541 72.48 28.34 72.48Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M48.5 72.48C50.8859 72.48 52.82 70.5458 52.82 68.16C52.82 65.7741 50.8859 63.84 48.5 63.84C46.1141 63.84 44.18 65.7741 44.18 68.16C44.18 70.5458 46.1141 72.48 48.5 72.48Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M32.66 68.16H44.18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="pest-grid-label">Warehouse Facilities</span>
          </div>
        </div>
      </article>
    </section>

    <section class="what-cesco-members">
      <h2>What is <br class="mo_show" />CESCO Members?</h2>
      <div>
        CESCO conducts systematic and intensive <br class="pc_show" />
        management to <br class="mo_show" />maintain the hygiene of <br class="mo_show" />nationwide <br class="pc_show" />
        workplaces and <br class="mo_show" />prevent infection. <br /><br />
        The ‘CESCO Members Mark’ <br class="mo_show" />certifies the workplaces <br class="pc_show" />
        where <br class="mo_show" />CESCO maintains strict and <br class="mo_show" />precise <br class="pc_show" />
        management.
      </div>
    </section>

    <section class="why-cesco-members">
      <h2 class="me-h2">
        Why
        <br v-if="mobileCheck" />
        CESCO Members?
      </h2>
      <div class="layout-box">
        <article class="content-box content-box-1">
          <div class="online-promotion-box-1">
            <div>
              <button class="btn-outline-blue">
                <span> Customers </span>
              </button>
            </div>
            <h4>
              Various global corporations are <br class="pc_show" />
              a part of our ‘CESCO Members’.
            </h4>
          </div>

          <div class="online-promotion-box-2">
            <img src="@/assets/images/main/promotion_corp.svg" alt="global corporations" />
          </div>
        </article>
        <article class="content-box content-box-2">
          <div>
            <div>
              <button class="btn-outline-blue">
                <span> Satisfaction </span>
              </button>
            </div>
            <h4>
              Over 450,000 <br class="mo_show" />
              customers satisfied <br class="mo_show" />
              with our services!
            </h4>
          </div>
          <div class="progress-layout">
            <div class="progress-box">
              <label class="tracking-[-0.03em]"> Consumer Perceptions of the 'CESCO Members Mark' </label>
              <div class="progress-bar-background" :class="{ ready: isReady }">
                <div class="progress-bar-foreground" style="width: 95%">
                  <span class="progress-label"> Hygienic</span>
                  <span class="progress-value">97%</span>
                </div>
              </div>
            </div>
            <div class="progress-box">
              <label class=""> Stores with the 'CESCO Members Mark' on Display </label>
              <div class="progress-bar-background" :class="{ ready: isReady }">
                <div class="progress-bar-foreground" style="width: 75%">
                  <span class="progress-label">
                    Increase in <br class="mo_show" />
                    Order Volume
                  </span>
                  <span class="progress-value">70%</span>
                </div>
              </div>
            </div>
            <div class="progress-sub">From the survey results conducted with Korean customers.</div>
          </div>
        </article>
      </div>

      <div class="join-cesco-btn">
        <button class="btn" @click="router.push('/homepage/info/whyMembers')">
          <b>Why CESCO Members?</b>
        </button>
      </div>
    </section>

    <section class="our-solutions">
      <h2>
        Our Diverse Solutions
        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </h2>

      <swiper ref="swiperRef" :slides-per-view="'auto'" @slideChange="onSlideChange" class="solution-items">
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/total')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide01.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>Integrated Pest Management Solution (IPM Solution)</h4>
                <p>Offers customized pest control from initial occurrence to preventing future infestations.</p>
              </div>

              <div>
                <img src="@/assets/images/icons/logo.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/bedbug')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide02.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>
                  Bedbug <br />
                  Control Solution
                </h4>
                <p>Handles bedbug issues from entry to rapid extermination upon detection.</p>
              </div>

              <div>
                <img src="@/assets/images/icons/logo.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/fly')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide03.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>Flying Insect Control Solution (FIC Solution)</h4>
                <p>Provides round-the-clock, phased care for airborne pests like flies, mosquitoes, and moths.</p>
              </div>

              <div>
                <img src="@/assets/images/icons/logo.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/airSterile')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide04.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>
                  Air <br />
                  Sterilizer
                </h4>
                <p>Features a preemptive virus attack system developed using CESCO’s advanced science.</p>
              </div>

              <div>
                <img src="@/assets/images/main/logo_viruscare.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/air')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide06.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>
                  Air <br />
                  Purifier
                </h4>
                <p>
                  Manages air quality by <br />
                  removing invisible airborne contaminants.
                </p>
              </div>

              <div>
                <img src="@/assets/images/main/logo_air.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/virusCare')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide05.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>
                  Viruscare <br />
                  Solution
                </h4>
                <p>Manages and prevents contamination areas with advanced virus disinfection.</p>
              </div>

              <div>
                <img src="@/assets/images/main/logo_viruscare.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/scent')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide08.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>Fragrance Solution Airperfume</h4>
                <p>Provides a differentiated fragrance consulting solution to create memorable and inviting spaces.</p>
              </div>

              <div>
                <img src="@/assets/images/main/logo_airperfume.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
        <swiper-slide class="swiper-slide" @click="router.push('/solution/service/water')">
          <article class="solution-item">
            <div>
              <img class="solution-item-img" src="@/assets/images/main/solution_slide10.png" />
            </div>
            <div class="content-layout">
              <div>
                <h4>
                  Water <br />
                  Purifier
                </h4>
                <p>
                  Enhances everyday water <br />
                  quality management with <br />
                  CESCO science.
                </p>
              </div>

              <div>
                <img src="@/assets/images/main/logo_water.svg" />
              </div>
            </div>
          </article>
        </swiper-slide>
      </swiper>
    </section>
  </main>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, inject } from 'vue'
import { useRouter } from 'vue-router'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useSlide } from '@/hooks'

const router = useRouter()

const { swiperRef, slidePrev, slideNext } = useSlide()

const mobileCheck = inject('mobileCheck')

const prevDisabled = ref(true)
const nextDisabled = ref(false)

/**
 * 슬라이드 체인지 이벤트
 * @param {*} e
 */
const onSlideChange = e => {
  const swiperIndex = e.realIndex

  if (swiperIndex === 0) prevDisabled.value = true
  else prevDisabled.value = false

  if (swiperIndex >= 4) nextDisabled.value = true
  else nextDisabled.value = false
}

// 프로그레스바 observer
const isReady = ref(false)
const observer = ref(null)

const toggleReady = entries => {
  if (isReady.value) return
  entries.forEach(entry => {
    isReady.value = entry.isIntersecting
  })
}

onMounted(() => {
  const target = document.querySelector('.progress-layout')

  observer.value = new IntersectionObserver(toggleReady, {
    threshold: 1.0 // div의 100%가 viewport에 들어올 때
  })

  if (target) {
    observer.value.observe(target)
  }
})

onBeforeUnmount(() => {
  if (observer.value) {
    observer.value.disconnect()
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/main.scss';
</style>
